export const endpoint = {
  API_BASE_URL: "https://vtomerchantcmsbackend.clouddeploy.in/api/v1",

  GET_STORES: "/demo/stores",
  GET_PRODUCTS: "/demo/products",
  GET_PRODUCTS_VARIANTS_BY_ID: "/demo/getSiblingVariantsbyVariantId",
  VALIDATE_PIN: "/demo/validate-pin",
};
